<template>
  <div v-if="notFound" class="view-mentorship container">
    <h2 class="mb-5">Opa, essa mentoria já terminou!</h2>
    <p>
      Fique ligado na programação das próximas mentorias na aba Mentorias e no
      Calendário de aulas.
    </p>
    <p>
      Ah, e lembre-se que todas as aulas e mentorias ficam gravadas para você
      assistir novamente. Após 2 dias úteis a finalização das mentorias ao vivo,
      elas são adicionadas nos respectivos módulos na aba lateral!
    </p>
  </div>

  <action-dispatcher
    v-else
    action="courses/getMentorship"
    :parameters="{ id: $route.params.id }"
    class="view-mentorship"
    @error="onError"
  >
    <div
      v-if="!mentorship.video_url && !mentorship.embed_code"
      class="container text-center"
    >
      <i class="fa-light fa-circle-info fa-2x mb-3 text-primary"></i>
      <h4 class="mb-4">Olá, não estamos ao vivo agora</h4>

      <p>
        As mentorias M60 acontecem ao vivo TODA SEMANA. Confira o calendário da
        sua turma
        <router-link :to="{ name: 'tools', params: { calendar: 'calendar' } }">
          &gt;&gt; aqui &lt;&lt;
        </router-link>
      </p>

      <p>
        Aproveite este intervalo para finalizar as aulas do Ciclo Básico do M60
        - as aulas já gravadas que estão disponíveis na sua plataforma.
      </p>
    </div>
    <div v-else class="container">
      <h2>{{ mentorship.title }}</h2>

      <div class="row">
        <div
          class="my-4"
          :class="{ 'col-xl-8': !isStreamyard, 'col-12': isStreamyard }"
        >
          <div
            v-if="mentorship.embed_code"
            v-html="mentorship.embed_code"
          ></div>
          <div v-else class="iframe-wrapper" :class="{ 'is-mobile': isMobile }">
            <div class="top-blocker"></div>
            <div class="bottom-blocker"></div>
            <iframe
              v-if="isMobile"
              :src="`${videoUrl}`"
              allow="autoplay; fullscreen"
            ></iframe>
            <iframe v-else :src="videoUrl" fs="0" allow="autoplay;"></iframe>
          </div>
        </div>

        <div v-if="!isStreamyard" class="col-xl-4 my-4">
          <small v-if="isMobile" class="d-block mb-3">
            Para utilizar o chat, é necessário estar logado no YouTube no seu
            navegador.
            <a href="https://www.youtube.com/" target="_blank">Clique aqui</a>
            para logar.
          </small>
          <div class="embed-responsive chat">
            <iframe
              class="embed-responsive-item"
              :src="chatUrl"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>

      <div v-html="mentorship.description" />

      <h5 v-if="mentorship.next_mentorships.length" class="mt-5 mb-3">
        Próximas mentorias
      </h5>
      <div class="mx-n3">
        <carousel
          :per-page="1.3"
          :per-page-custom="[
            [500, 2.3],
            [800, 3.3],
            [1100, 4]
          ]"
          pagination-enabled
          navigation-enabled
          navigation-next-label="<i class='icon-chevron-right'></i>"
          navigation-prev-label="<i class='icon-chevron-left'></i>"
        >
          <slide
            v-for="(item, index) in mentorship.next_mentorships"
            :key="index"
          >
            <router-link :to="{ params: { ...item } }" class="px-3">
              <img :src="item.cover" />
              <h5 class="mt-3 mb-1">{{ item.title }}</h5>
              <div class="text-secondary">
                {{ toHumanDate(item.start_at, true) }}
              </div>
            </router-link>
          </slide>
        </carousel>
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import { toHumanDate, youtubeParser } from "@/functions/helpers";
import isMobile from "ismobilejs";

export default {
  data() {
    return {
      notFound: false,
      isMobile: isMobile(window.navigator).any
      // ,mentorship: {
      //   video_url: "https://www.youtube.com/watch?v=lR41td2YaD4",
      //   next_mentorships: [],
      //   description: "",
      //   title: "Mockup",
      //   // embed_code: `<div style="width:100%;height:0px;position:relative;padding-bottom:56.25%;"><iframe src="https://streamyard.com/watch/Q5FqJWAPgmtg?embed=true" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" style="width:100%;height:100%;position:absolute;left:0px;top:0px;overflow:hidden;"></iframe></div>`
      // }
    };
  },
  computed: {
    ...mapState("courses", ["mentorship"]),
    youtubeId() {
      return youtubeParser(this.mentorship.video_url);
    },
    isStreamyard() {
      return (
        this.mentorship.embed_code ||
        this.mentorship.video_url.includes("streamyard")
      );
    },
    videoUrl() {
      if (this.isStreamyard) {
        return this.mentorship.video_url;
      }
      return `https://www.youtube.com/embed/${this.youtubeId}?rel=0&autoplay=1`;
    },
    chatUrl() {
      return `https://www.youtube.com/live_chat?v=${this.youtubeId}&embed_domain=${document.location.hostname}`;
    }
  },
  methods: {
    toHumanDate,
    onError(error) {
      if (error.response.status == 404) {
        this.notFound = true;
      }
    }
  }
};
</script>

<style lang="scss">
.view-mentorship {
  padding-top: calc(81px + 24px);

  img {
    width: 100%;
    aspect-ratio: 16 / 9;
  }

  .iframe-wrapper {
    overflow: hidden;
    position: relative;
    height: 0;
    padding-top: calc(9 / 16 * 100%);

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      border: none;
      width: 100%;
      height: 100%;
    }

    .top-blocker {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 60px;
    }

    .bottom-blocker {
      position: absolute;
      z-index: 1;
      bottom: 0;
      height: 36px;
      right: 50px;
      width: 74px;
      left: unset;
    }

    &.is-mobile {
      padding-top: calc(9 / 15 * 100%);

      .bottom-blocker {
        right: 56px;
      }
    }
  }

  .VueCarousel-navigation-prev,
  .VueCarousel-navigation-next {
    background: rgba(0, 0, 0, 0.5);
  }
  .VueCarousel-navigation-next {
    right: 16px;
  }
  .VueCarousel-navigation-prev {
    left: 16px;
  }

  .VueCarousel-slide a {
    display: block;
    text-decoration: none;
    color: white;
  }

  .embed-responsive.chat {
    padding-top: 0;
    min-height: 320px;

    @media screen and (min-width: 992px) {
      height: 100%;
    }
  }
}
</style>
